<div class="page">
  <p-toast></p-toast>
  <div class="layout">
    <div class="left-side">
      <img class="logo" src="../../../../../assets/images/logo2.svg" alt="" />
      <div class="vector-layer">
        <img
          class="left-image"
          src="../../../assets/vectors/auth-vector1.svg"
          alt=""
        />
      </div>
      <div class="base-layer">
        <div class="base-text">
          <span class="base-title">Streamlining Efficiencies in Webhook Management</span>
          <span class="base-label">
            Webhook Manager simplifies setup, monitoring, and optimization with a
            user-friendly interface, ensuring seamless communication, real-time
            data sync, and instant notifications. Elevate efficiency
            effortlessly.
          </span>
        </div>
      </div>
    </div>
    <div class="right-side">
      <img class="logo" src="../../../../../assets/images/logo.svg" alt="" />
      <div class="form-holder">
        <div class="form-container">
          <h1>Login</h1>
          <p>Welcome back! Login to continue</p>
          <app-error-message [message]="errorMessage"></app-error-message>

          <div class="form">
            <div>
              <app-input
                (dataEvent)="email($event)"
                label="Email"
                placeholder="Enter your email"
              ></app-input>
            </div>
            <div>
              <app-input
                (dataEvent)="password($event)"
                type="password"
                label="Password"
                placeholder="Enter your password"
                (enterPressed)="handleEnterPressed()"
              ></app-input>
            </div>
            <div>
              <p class="forgot" (click)="forgotPassword()">forgot password?</p>
            </div>
            <!-- <app-button-fill buttonText="Login" (loginClick)="login()"></app-button-fill> -->
            <app-button-fill
              [processLoading]="isLoading"
              [action]="signin"
              buttonText="Login"
            ></app-button-fill>
            <div class="create-account">
              <p>
                I dont have an account!
                <a (click)="register()" class="login-link">Create Account →</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
